export const NONE_KEY = '__none__';
export const EMPTY_VALUE_KEY = '__technical_empty_code__';
export const ALL_VALUE = '__all__';
export const LOADING_KEY = '__loading__';
